import { IRouteMatch } from './IRouteMatch';

export function parseRouteMatch<TMatch extends { [name: string]: any; }>(
  match: IRouteMatch,
  defaultValues: TMatch,
  parsers?: Partial<Record<keyof TMatch, (v: string) => any>>
): TMatch {

  const result = { ...defaultValues };

  for (const n in defaultValues) {

    const value: any = match?.params?.[n] !== undefined
      ? match.params[n]
      : match.search?.[n];

    if (value != null) {
      const parser = (v: string) => {
        v = decodeURIComponent(v);

        if (parsers && parsers[n])
          v = parsers[n]!(v);
        return v;
      };

      result[n] = Array.isArray(defaultValues[n])
        ? value.map(parser)
        : parser(value[0]);
    }
  }

  return result;
}
